import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import groups from './groups';
import orders from './orders';
import properties from './properties';
import ToDo from './toDoList';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/groups`} component={groups} />
      <Route path={`${match.url}/properties`} component={properties} />
      <Route path={`${match.url}/orders`} component={orders} />
      <Route path={`${match.url}/todo`} component={ToDo} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
